export const getLastSyncInformation = async (props: any, group_code: string) => {
    let error: string = '';
    let date: any = '';
    await props.di.POST('frontend/config/getLastSyncInfo', {
        "group_code": group_code
    }).then((response: any) => {
        if (response?.success && response?.data) {
            let updatedInfo = response?.data?.[0]?.['updated_at'] ?? (response?.data?.[0]?.['created_at'] ?? '');
            if (updatedInfo !== '') {
                date = new Date(updatedInfo);
                let a = new Date(date.getTime() + date.getTimezoneOffset()).toString().substring(0, 25);
                date = date.toUTCString();
            }

        }
        else { //front end se api call mein agar koi error hogi
            error = `Error while getting updated_at date of ${group_code}`;
        }
    });
    return { date, error };
}